var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('v-btn',{staticClass:"button-base",attrs:{"depressed":"","color":"primary"},on:{"click":_vm.goSignerPage}},[_vm._v("Подписать ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }